import { Configuration, RedirectRequest } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID || '';
const redirectUri = process.env.REACT_APP_ENTRA_REDIRECT_URI || `${window.location.origin}/auth/callback/entra`;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
};
